const CAP22 = {
  id: 22,
  slug: "cap22-historia-blockchain-i",
  title: "Capítulo 22 — Historia de la tecnología Blockchain (I)",
  sections: [
    {
      heading: "Introducción",
      text: [
        "Aunque la tecnología blockchain está estrechamente vinculada a la primera criptomoneda descentralizada, su creación es el resultado de décadas de investigación y desarrollo.",
        "Desde los primeros conceptos de criptografía de clave pública, pasando por los sistemas de sellado de tiempo (timestamping) y la validación mediante hash, hasta la propuesta de un sistema descentralizado seguro, blockchain ha recorrido un largo camino.",
        "Tras la llegada del sistema descentralizado basado en blockchain, surgieron los contratos inteligentes, las aplicaciones descentralizadas (DApps) y múltiples mejoras criptográficas. Hoy, la tecnología sigue evolucionando y abriendo oportunidades en un mundo cada vez más digital."
      ]
    },
    {
      heading: "Los primeros pasos: timestamping y estructura encadenada",
      text: [
        "La tecnología blockchain tiene sus raíces en la década de 1990, cuando investigadores como Stuart Haber y W. Scott Stornetta propusieron un sistema de sellado de tiempo (timestamping) para proteger documentos digitales contra modificaciones.",
        "El objetivo era registrar documentos de manera que, una vez sellados, no pudieran ser alterados sin dejar rastro.",
        "Estos investigadores utilizaron hash criptográfico para vincular los documentos entre sí, formando una estructura encadenada: cada documento contenía el hash del documento anterior, creando así una cadena segura y cronológica, precursora del concepto de blockchain."
      ]
    },
    {
      heading: "El aporte de los Árboles de Merkle",
      text: [
        "En 1992, Ralph Merkle introdujo el concepto de Árbol de Merkle (Merkle Tree) al sistema de timestamping.",
        "Un Árbol de Merkle es una estructura de datos que permite organizar grandes cantidades de información y verificar su integridad de forma rápida y eficiente.",
        "Esta estructura genera un hash raíz (Merkle Root) que funciona como una huella digital única del conjunto de datos. Si una sola parte se modifica, el hash completo cambia, permitiendo detectar cualquier intento de manipulación.",
        "Esta mejora permitió que los sistemas criptográficos fueran más eficientes y resistentes a ataques, y se convirtió en una pieza fundamental para el desarrollo de blockchain."
      ]
    },
    {
      heading: "Criptografía de clave pública: el corazón de la seguridad",
      text: [
        "Otro avance clave en la historia de blockchain es la criptografía de clave pública.",
        "En los años 70, investigadores desarrollaron sistemas criptográficos que permitían cifrar y descifrar mensajes sin necesidad de compartir previamente una clave privada.",
        "Este hito permitió la creación de mecanismos de comunicación seguros, firma digital y verificación de identidad —elementos esenciales que más tarde serían integrados en blockchain.",
        "La criptografía de clave pública permite que una persona firme digitalmente una transacción con su clave privada, y cualquier participante de la red pueda verificarla usando la clave pública. Esto hace posible la confianza sin intermediarios."
      ]
    },
    {
      heading: "Proof of Work: antes que blockchain",
      text: [
        "En 1997, se propuso un mecanismo llamado Proof of Work (PoW), cuyo objetivo inicial era combatir el correo no deseado (spam) en internet.",
        "Este sistema requería que quien enviara un mensaje realizara un pequeño cálculo computacional como prueba de esfuerzo. Así, se desincentivaba el envío masivo de mensajes basura.",
        "Más tarde, este mismo mecanismo fue adaptado para verificar transacciones en redes descentralizadas, convirtiéndose en la base del mecanismo de minería que hoy utilizan muchas blockchains."
      ]
    },
    {
      heading: "Cadenas criptográficas seguras",
      text: [
        "En el año 2000, se introdujo el concepto de cadenas criptográficas seguras, donde cada bloque está vinculado al anterior mediante hashes, formando una cadena.",
        "Este diseño permitió que cualquier modificación en un bloque afectara a toda la cadena, haciendo evidente cualquier intento de alteración.",
        "Este concepto fue fundamental para el desarrollo posterior de la tecnología blockchain, ya que sentaba las bases de su **inmutabilidad**."
      ]
    },
    {
      heading: "Reusable Proof of Work (2004): el precursor del dinero digital",
      text: [
        "En 2004, el investigador Hal Finney propuso un sistema llamado Reusable Proof of Work (RPoW), que permitía crear tokens digitales únicos, que podían ser transferidos entre usuarios.",
        "Estos tokens no podían ser duplicados ni falsificados, lo que los convertía en un verdadero antecedente de las criptomonedas modernas.",
        "RPoW fue uno de los primeros intentos de crear dinero digital descentralizado sin intermediarios."
      ]
    },
    {
      heading: "El camino hacia la blockchain moderna",
      text: [
        "La combinación de todas estas innovaciones —criptografía de clave pública, timestamping, Árboles de Merkle, Proof of Work y cadenas criptográficas seguras— sentó las bases para el surgimiento de blockchain.",
        "Todas estas tecnologías se unieron finalmente en un sistema funcional, seguro, descentralizado y resistente a la falsificación.",
        "Ese sistema fue el que se presentó al mundo en 2008, y transformó para siempre la forma en que intercambiamos valor digital."
      ]
    }
  ]
};

export default CAP22;
